export class Helper {
  togglePassword(inputId: string, icon: JQuery<HTMLElement>): void {
    icon.toggleClass("fa-eye fa-eye-slash");
    const input = $(inputId);
    const isPassword = input.attr("type") === "password";
    input.attr("type", isPassword ? "text" : "password");
  }
}

export function LoadPage() {
  (window as any).helper = new Helper();
}
